var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalVisit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.448 11.362c-1.11.103-2.995.387-4.848 1.186V4.504c1.892-1.338 3.96-1.451 5.056-1.391.114.006.244.105.244.308v7.481c0 .218-.185.435-.452.46zM8 3.459c2.176-1.496 4.51-1.61 5.721-1.545.837.046 1.379.757 1.379 1.507v7.481c0 .887-.708 1.577-1.541 1.655-1.222.113-3.367.455-5.276 1.472M8 3.46C5.823 1.963 3.49 1.85 2.279 1.914c-.837.046-1.38.757-1.38 1.507v7.481c0 .887.709 1.577 1.542 1.655 1.222.113 3.366.455 5.275 1.472l.045.022a.6.6 0 00.521-.021M7.4 12.548V4.504C5.507 3.166 3.44 3.053 2.344 3.113c-.114.006-.244.105-.244.308v7.481c0 .218.185.435.452.46 1.11.103 2.995.387 4.848 1.186z",
    fill: "#A8AAAD"
  })));
}
export default __webpack_public_path__ + "static/external_visit.6abc19d8.svg";
export { SvgExternalVisit as ReactComponent };